import { render, staticRenderFns } from "./EditFichaDiarioAtendimento.vue?vue&type=template&id=2b181e40"
import script from "./EditFichaDiarioAtendimento.vue?vue&type=script&lang=js"
export * from "./EditFichaDiarioAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports